import { isDevMode } from '@angular/core';
import { Routes } from '@angular/router';
import { brandGuard } from '@guards/brand/brand.guard';
import { cmsPathGuard } from '@guards/cms-path/cms-path.guard';
import { featureActiveGuard } from '@guards/feature-active/feature-active.guard';
import { CmsPageEnum } from '@models/copy/cms-page-map.model';
import { FeatureFlagEnum } from '@models/enums/feature-flag.enum';
import { CmsCopyResolver } from '@services/cms/cms-copy.resolver';

export const routes = () => {
  const routes: Routes = [
    {
      path: `communication-preference`,
      loadChildren: () =>
        import('./pages/communication/communication.routes').then(
          (m) => m.routes,
        ),
      canActivate: [brandGuard, featureActiveGuard],
      data: {
        featureFlag: FeatureFlagEnum.COMMUNICATION,
      },
    },
    {
      path: `customer-survey`,
      loadChildren: () =>
        import('./pages/customer-survey/customer-survey.routes').then(
          (m) => m.routes,
        ),
      canActivate: [brandGuard, featureActiveGuard],
      data: {
        featureFlag: FeatureFlagEnum.CUSTOMER_SURVEY,
      },
    },
    {
      path: `pay`,
      loadChildren: () =>
        import('./pages/pay/pay.routes').then((m) => m.routes),
      canActivate: [brandGuard, featureActiveGuard],
      data: {
        featureFlag: FeatureFlagEnum.PAY,
      },
    },
    {
      path: `schedule`,
      loadComponent: () =>
        import('./pages/schedule/schedule.page').then((p) => p.SchedulePage),
      loadChildren: () =>
        import('./pages/schedule/schedule.routes').then((m) => m.routes),
      canActivate: [brandGuard, featureActiveGuard],
      data: {
        featureFlag: FeatureFlagEnum.SCHEDULE,
      },
    },
    {
      path: `service-request`,
      loadChildren: () =>
        import('./pages/service-request/service-request.routes').then(
          (m) => m.routes,
        ),
      canActivate: [brandGuard, featureActiveGuard],
      data: {
        featureFlag: FeatureFlagEnum.REQUEST_SERVICE,
      },
    },
    {
      path: `not-found`,
      loadComponent: () =>
        import('./pages/not-found/not-found.page').then((p) => p.NotFoundPage),
      canActivate: [brandGuard, cmsPathGuard],
      resolve: { copy: CmsCopyResolver },
      data: {
        cmsPath: CmsPageEnum.NOT_FOUND,
      },
    },
  ];

  if (isDevMode()) {
    routes.push({
      path: `style-guide`,
      loadChildren: () =>
        import('./pages/style-guide/style-guide.routes').then((m) => m.routes),
      canActivate: [brandGuard, featureActiveGuard],
      data: {
        featureFlag: FeatureFlagEnum.STYLE_GUIDE,
      },
    });
  }

  routes.push({
    path: '',
    loadComponent: () =>
      import('./pages/dynamic/dynamic.page').then((p) => p.DynamicPage),
    canActivate: [brandGuard, featureActiveGuard, cmsPathGuard],
    pathMatch: 'full',
    resolve: { copy: CmsCopyResolver },
    data: {
      featureFlag: FeatureFlagEnum.BROCHURE_SITE,
      redirectIfInactive: '/pay', // example of redirecting to an active feature if the brochure site flag is off
    },
  });

  routes.push({
    path: `**`,
    loadComponent: () =>
      import('./pages/dynamic/dynamic.page').then((p) => p.DynamicPage),
    canActivate: [brandGuard, cmsPathGuard],
    resolve: { copy: CmsCopyResolver },
  });

  return routes;
};
